import { put, call, takeEvery, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';

function* customerAddressCepRequest({ cep }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(customerAPI.findAddressByPostalCode, cep, siteId);

    yield put(Creators.customerAddressCepSuccess(data));
  } catch (error) {
    const formatedError = formatError(error);
    yield put(AppCreators.feedbackRequest({ open: true, message: formatedError.message }));
    yield put(Creators.customerAddressCepFailed(formatedError));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ADDRESS_CEP_REQUEST, customerAddressCepRequest);
}
